// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1SJJV","disabled":"FileBtn_disabled__6LSS2","warn":"FileBtn_warn__HmVYM","fade":"FileBtn_fade__1HAdu"};